import { pointerWithin, closestCenter } from '@dnd-kit/core'

function isRankingDropId(id) {
	return typeof id === 'string' && id.startsWith('rank:drop:')
}

/**
 * Prefer pointer hits; when the pointer is over sortable tiles, use those instead of the large row droppable.
 */
export function rankingCollisionDetection(args) {
	const pointerCollisions = pointerWithin(args)
	if (pointerCollisions.length > 0) {
		const overTile = pointerCollisions.filter((c) => !isRankingDropId(c.id))
		if (overTile.length > 0) return overTile
		return pointerCollisions
	}
	return closestCenter(args)
}
